import { DealValue } from "src/app/features/prob/models/deal-value";
import { RateItem } from "./rate-item";

/**
 * Manages the deal value grid table data
 */
export class DealValueGridData {

  /**
   * The number of rows of data in the grid table
   */
  rowCount: number = 0;

  /**
   * The grid table model value identifier
   */
  modelValueGridId: string = '';

  /**
   * The collection of deal value grid data
   */
  dealValues: DealValue[] = [];

  /**
   * The collection of values from any calculated sums
   */
  calcValues: DealValue[] = [];

  isInvalidGridExist: boolean = false;

  // To get the rateItem of blended rates from deal tab
  

}
